import { render } from "./molde_aberto.vue?vue&type=template&id=bc466c3e"
import script from "./molde_aberto.vue?vue&type=script&lang=js"
export * from "./molde_aberto.vue?vue&type=script&lang=js"

import "./molde_aberto.vue?vue&type=style&index=0&id=bc466c3e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__